import React from 'react';
import { IconButton } from 'wix-ui-tpa/cssVars';
import { Close } from '@wix/wix-ui-icons-common/on-stage';
import { classes } from './header.st.css';
import { useWaiverSignWidgetBI, BI_ACTION, BI_VALUE } from '../../../bi';

export const Header = ({ onClose }: { onClose?: () => void }) => {
  const { WaiverFormActionsBI } = useWaiverSignWidgetBI();

  const handleClose = () => {
    WaiverFormActionsBI({
      action: BI_ACTION.CLICK,
      value: BI_VALUE.CLOSE,
    });
    onClose?.();
  };

  return (
    <div className={classes.root}>
      <IconButton icon={<Close />} onClick={handleClose} />
    </div>
  );
};
